import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {from, of} from 'rxjs';
import {first} from 'rxjs/operators';
import imageCompression from 'browser-image-compression';
import {DOC_ORIENTATION} from "ngx-image-compress/lib/models/DOC_ORIENTATION";
import {NgxImageCompressService} from "ngx-image-compress";

export interface AvatarCropDialogData {
  fileBase64: string;
  ratio: number;
  roundCropper: boolean;
  maintainRatio: boolean;
  compressedFile: boolean;
}

@Component({
  selector: 'app-avatar-crop-dialog',
  templateUrl: './avatar-crop-dialog.component.html',
  styleUrls: ['./avatar-crop-dialog.component.scss']
})
export class AvatarCropDialogComponent implements OnInit {

  fileBase64: string;
  croppedImage: any = '';
  progress = 0;
  ratio = 1;
  roundCropper = true;
  maintainRatio = true;
  compressedFile  = false;

  constructor(
    private imageCompress: NgxImageCompressService,
    public dialogRef: MatDialogRef<AvatarCropDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AvatarCropDialogData
  ) {
    this.ratio = data.ratio;
    this.roundCropper = data.roundCropper;
    this.maintainRatio = data.maintainRatio;
    this.compressedFile = data.compressedFile;
    of(
      this.dataURLtoBlob(data.fileBase64)
    ).pipe(first()).subscribe((file: File) => {
      from(
        imageCompression(file, {
          maxSizeMB: 1,
          onProgress: (progress: number) => this.progress = progress,
        })
      ).pipe(first()).subscribe((compressedFile: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedFile);
        reader.onload = () => {
          this.fileBase64 = reader.result.toString();
        };
      });
    });
  }

  ngOnInit(): void {
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
  }

  loadImageFailed(): void {

  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    of(
      this.dataURLtoBlob(this.croppedImage)
    ).pipe(first()).subscribe((file: File) => {
      from(
        imageCompression(file, {
          maxSizeMB: 0.2,
          onProgress: (progress: number) => this.progress = progress,
        })
      ).pipe(first()).subscribe((compressedFile: File) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedFile);
        reader.onload = () => {
          const fileBase64 = reader.result.toString();
          if (this.compressedFile) {
            const orientation: DOC_ORIENTATION = 3;
            this.imageCompress
              .compressFile(fileBase64, orientation, 90, 90, 70, 70) // 50% ratio, 50% quality
              .then(compressedImage => {
                this.dialogRef.close('data:image/png;base64,' + (/base64,(.+)/.exec(compressedImage)[1]));
              });
          } else {
            this.dialogRef.close(/base64,(.+)/.exec(fileBase64)[1]);
          }
        };
      });
    });
  }

  dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
  }
}
